/**
* Treatment Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Hero component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    className: 'treatment-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.treatment-hero__slider' ).length ) {
        $( '.treatment-hero__slider' ).each( function( key, component ) {
          new Splide( component, {
            type: 'loop',
            autoWidth: true,
            arrows: false,
            gap: '0.75rem',
            pagination: false,
            autoScroll: {
              pauseOnHover: false,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
      $( this.selector() ).each( function() {
        const $container = $( this );
        const $logo = $container.find( '.treatment-hero__slide-in-logo' );

        ScrollTrigger.create( {
          trigger: $logo,
          start: 'top 80%',
          onEnter: () => {
            $( $logo ).addClass( 'in-view' );
          },
        } );
      } );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-hero', COMPONENT );
} )( app );
